import React, { useState } from 'react';
import { FiDownload } from 'react-icons/fi';

const ExportButton = ({ 
  onExport, 
  label = "Export", 
  className = "", 
  disabled = false,
  size = "md",
  variant = "primary"
}) => {
  const [isExporting, setIsExporting] = useState(false);
  const [exportMessage, setExportMessage] = useState("");

  const handleExport = async () => {
    if (isExporting || disabled) return;
    
    setIsExporting(true);
    setExportMessage("");
    
    try {
      const result = await onExport();
      if (result.success) {
        setExportMessage(result.message);
        setTimeout(() => setExportMessage(""), 3000);
      } else {
        setExportMessage(result.message);
      }
    } catch (error) {
      setExportMessage("Export failed. Please try again.");
    } finally {
      setIsExporting(false);
    }
  };

  const sizeClasses = {
    sm: "px-3 py-1.5 text-sm",
    md: "px-4 py-2 text-sm",
    lg: "px-6 py-3 text-base"
  };

  const variantClasses = {
    primary: "text-white",
    secondary: "text-white",
    success: "text-white",
    outline: "border border-gray-600 text-gray-300 hover:bg-gray-700"
  };

  return (
    <div className="flex flex-col items-center">
      <button
        onClick={handleExport}
        disabled={disabled || isExporting}
        className={`
          ${sizeClasses[size]}
          ${variantClasses[variant]}
          ${className}
          inline-flex items-center gap-2 rounded-lg font-medium transition-colors
          disabled:opacity-50 disabled:cursor-not-allowed
          focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
        `}
        style={{
          background: variant === 'outline' ? 'transparent' : 'linear-gradient(270deg, rgb(75, 73, 172) 0.05%, rgb(153, 153, 255) 99.97%)'
        }}
      >
        {isExporting ? (
          <>
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
            Exporting...
          </>
        ) : (
          <>
            <FiDownload className="h-4 w-4" />
            {label}
          </>
        )}
      </button>
      
      {exportMessage && (
        <div className={`mt-2 text-xs ${exportMessage.includes('successfully') ? 'text-green-500' : 'text-red-500'}`}>
          {exportMessage}
        </div>
      )}
    </div>
  );
};

export default ExportButton;
